import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import TrialsOverview from './pages/TrialsOverview';
import TrialView from './pages/TrialView';
import TrialEdit from './pages/TrialEdit';
import Dashboard from './pages/Dashboard';
import { isAuthenticated } from './auth';
import { VanoCodesProvider } from './context/VanoCodesProvider';
import ProfilePage from './pages/Profile';
import UserSettingsPage from './pages/UserSettings';
import InboxPage from './pages/Inbox';
import Layout from './components/Layout';
import Customers from './pages/masterdata/Customers';
import Hosts from './pages/masterdata/Hosts';
import Contracts from './pages/masterdata/Contracts';
import Users from './pages/masterdata/Users';
import Projects from './pages/masterdata/Projects';
import Country from './pages/masterdata/Country';
import Crops from './pages/masterdata/Crops';
import StudyTypes from './pages/masterdata/StudyTypes';
import TrialType from './pages/masterdata/TrialType';
import TrialNew from './pages/TrialNew';
import { Toaster } from 'sonner';
import ExistingLayoutFlow from './pages/reports/ExistingLayoutFlow';

function PrivateRoute({ children }) {
  // VanoCodesProvider sits here (post-auth-check), not above the Router: the catalog endpoint
  // requires auth, so fetching it before we know the user is logged in would always fail and
  // - since the provider gates rendering on success - would make /login unreachable. Placing
  // it inside PrivateRoute means the fetch only ever starts once isAuthenticated() is true,
  // and /login is entirely unaffected.
  return isAuthenticated() ? (
    <VanoCodesProvider>{children}</VanoCodesProvider>
  ) : (
    <Navigate to="/login" />
  );
}

export default function App() {
  return (
  <>
    <Toaster />
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={
          <PrivateRoute>
            <Layout>
              <Dashboard />
            </Layout>
          </PrivateRoute>
        } />
        <Route path="/inbox" element={
          <PrivateRoute>
            <Layout>
              <InboxPage />
            </Layout>
          </PrivateRoute>
        } />
        {/* Planning is parked ("nice to have"): no route and no menu item, its code (pages/Planning.jsx) is kept */}
        <Route path="/profile" element={
          <PrivateRoute>
            <Layout>
              <ProfilePage />
            </Layout>
          </PrivateRoute>
        } />
        <Route path="/trials" element={
          <PrivateRoute>
            <Layout>
              <TrialsOverview />
            </Layout>
          </PrivateRoute>
        } />
        <Route path="/trials/:id" element={
          <PrivateRoute>
            <Layout>
              <TrialView />
            </Layout>
          </PrivateRoute>
        } />
        <Route path="/trials/:id/edit" element={
          <PrivateRoute>
            <Layout>
              <TrialEdit />
            </Layout>
          </PrivateRoute>
        } />
        <Route path="/settings" element={
          <PrivateRoute>
            <Layout>
              <UserSettingsPage />
            </Layout>
          </PrivateRoute>
        } />
        <Route path="/customers" element={<PrivateRoute><Customers /></PrivateRoute>} />
        <Route path="/reports" element={<PrivateRoute><ExistingLayoutFlow /></PrivateRoute>} />
        <Route path="/hosts" element={<PrivateRoute><Hosts /></PrivateRoute>} />
        <Route path="/contracts" element={<PrivateRoute><Contracts /></PrivateRoute>} />
        <Route path="/users" element={<PrivateRoute><Users /></PrivateRoute>} />
        <Route path="/projects" element={<PrivateRoute><Projects /></PrivateRoute>} />
        <Route path="/country" element={<PrivateRoute><Country /></PrivateRoute>} />
        <Route path="/crops" element={<PrivateRoute><Crops /></PrivateRoute>} />
        <Route path="/study-types" element={<PrivateRoute><StudyTypes /></PrivateRoute>} />
        <Route path="/trialtype" element={<PrivateRoute><TrialType /></PrivateRoute>} />
        <Route path="/trials/new" element={<PrivateRoute><TrialNew /></PrivateRoute>} />
      {/* Experiments page removed */}
      </Routes>
      </BrowserRouter>
    </>
  );
}
